import type { PunchKey, RecebimentoTipo } from './types';

export const PUNCH_TYPES: { key: PunchKey; label: string }[] = [
  { key: 'entrada', label: 'Entrada' },
  { key: 'saida_descanso', label: 'Saída descanso' },
  { key: 'volta_descanso', label: 'Volta descanso' },
  { key: 'saida', label: 'Saída' },
];

export function labelOf(key: string): string {
  return PUNCH_TYPES.find((p) => p.key === key)?.label || key;
}

export const DOC_TYPES = ['Registro de Empregado', 'Contrato de Trabalho', 'Ficha de Empregado', 'Atestado de Saúde Ocupacional (ASO)', 'Registro de Rescisão', 'Outro'];

export const RECV_TYPES: Record<RecebimentoTipo, { label: string; ph: string }> = {
  vt: { label: 'Vale-Transporte', ph: 'Ex: 10 passagens de ônibus' },
  uniforme: { label: 'Uniforme', ph: 'Ex: 1 camiseta tamanho M, 1 boné' },
  epi: { label: 'EPI', ph: 'Ex: 1 par de luvas, 1 protetor auricular, 1 par de botas' },
};
